import * as React from 'react';
const classNames = require('classnames');

import { SectionMain } from '../../components/sections';

interface Props {
	wrapperClassName?: string;
	sectionClassName?: string;
	children?: {};
}

const PageFooter: React.StatelessComponent<Props> = ({ wrapperClassName, sectionClassName, children }) => {
	return (
		<SectionMain wrapperClassName={classNames('my-4', wrapperClassName)} sectionClassName={sectionClassName}>
			{children}
		</SectionMain>
	);
};

export default PageFooter;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/PageContent.tsx